export default __webpack_public_path__ + "static/media/aboutBg.a36b26de.png";